import Menus from "../Menus"

const HelpTopicRemboursement = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Remboursements', link: '/topics/paiement/remboursements'},
  ]

  const multiMenus = [
    {title: null, filter: 'HelpTopicRemboursement'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus} desiredOrder={[48]}/>
}

export default HelpTopicRemboursement